import { formatCurrency, formatDate, getAmsBaseUrl, historyTabs, newTranslate, rentContractStates } from "@awe-web/shared/lib";
import { List, Map, fromJS } from "immutable";
import { createSelector } from "reselect";
import { getHistoryPageSize } from "../config/store.js";

const RESERVATION = "FSD0000337";
const CHECK_OUT = "FSD0000338";
const CANCELLED = "FSD0000340";
const COMPLETED = "FSD0000339";

export default function reducer(state = {}, action) {
  switch (action.type) {
    case "HISTORY/RESERVATION_HISTORY_LOADED": {
      const currentPage = state?.historyPage ? state?.historyPage : 1;
      const currentTab = state?.historyTab ? state?.historyTab : historyTabs.ACTIVE;
      const currentFilterValues = getInternalFilterValues(state).toJS();
      const expectedParams = Map([
        ["page", currentPage],
        ["tab", currentTab],
        ["filterValues", currentFilterValues]
      ]);
      const actualParams = fromJS(action.payload.params || {});


      return deepEqual(expectedParams.toJS(), actualParams.toJS())
        ? {
          ...state,
          reservationHistory: action.payload.history,
          numberOfHistoryItems: action.payload.totalNumberOfItems
        }
        : state;



      // return is(expectedParams, actualParams)
      // ? state
      //   .set("reservationHistory", fromJS(action.payload.history))
      //   .set("numberOfHistoryItems", action.payload.totalNumberOfItems)
      // : state;
    }

    case "USER/USER_LOGGED_OUT":
      return {
        ...state,
        reservationHistory: null,
        numberOfHistoryItems: null,
        historyPage: null,
        historyTab: null,
        historyFilter: null
      };
    // return state
    //   .delete("reservationHistory")
    //   .delete("numberOfHistoryItems")
    //   .delete("historyPage")
    //   .delete("historyTab")
    //   .delete("historyFilter");

    case "HISTORY/PAGE_SELECTED":
      return {
        ...state,
        historyPage: action.payload.page
      };
    // return state.set("historyPage", action.payload.page);

    case "HISTORY/TAB_SELECTED":
      return {
        ...state,
        historyTab: action.payload.tab
      };
    // return state.set("historyTab", action.payload.tab);

    case "HISTORY/FILTER_SELECTED":
      return {
        ...state,
        historyFilter: action.payload.filterValues
      };
    // return state.set("historyFilter", fromJS(action.payload.filterValues));

    default:
      return state;
  }
}

const getReservationHistoryFromState = (state) => state?.history?.reservationHistory;

const getRawReservationHistory = createSelector(
  [getReservationHistoryFromState],
  (reservationHistory) => reservationHistory ? fromJS(reservationHistory) : List()
);

const getCurrentPageFromState = state => state?.history?.historyPage;

export const getCurrentPage = createSelector(
  [getCurrentPageFromState],
  (currentPage) => currentPage ? currentPage : 1
);

const getNumberOfHistoryItemsFromState = state => state?.history?.numberOfHistoryItems;

const getNumberOfHistoryItems = createSelector(
  [getNumberOfHistoryItemsFromState],
  (numberOfHistoryItems) => (numberOfHistoryItems !== undefined && numberOfHistoryItems !== null) ? numberOfHistoryItems : 0
);

export const getNumberOfPages = createSelector(
  [getHistoryPageSize, getNumberOfHistoryItems],
  (pageSize, numberOfItems) => Math.ceil(numberOfItems / pageSize)
);

export const getCsvExportUrl = createSelector(
  [getAmsBaseUrl],
  (amsBaseUrl) => `${amsBaseUrl}/v1.2/rentcontract/bookinghistorycsv`
);

const getActiveTabFromState = state => state?.history?.historyTab;

export const getActiveTab = createSelector(
  [getActiveTabFromState],
  (activeTab) => activeTab ? activeTab : historyTabs.ACTIVE
);

const getHistoryFilterFromState = state => state?.history?.historyFilter;

const getHistoryFilter = createSelector(
  [getHistoryFilterFromState],
  (historyFilter) => historyFilter ? fromJS(historyFilter) : List()
);

const getRegistrationNumber = createSelector(
  [getHistoryFilter],
  (historyFilter) => historyFilter.get("registrationNumber")
);

const getDriverName = createSelector(
  [getHistoryFilter],
  (historyFilter) => historyFilter.get("driverName")
);

const getInternalFilterValues = (state) => {
  const historyFilter = state?.historyFilter ? fromJS(state?.historyFilter) : List();
  const registrationNumber = historyFilter.get('registrationNumber', "");
  const driverName = historyFilter.get('driverName', "");
  return Map([
    ["registrationNumber", registrationNumber],
    ["driverName", driverName]
  ]);
};

export const getFilterValues = createSelector(
  [
    getRegistrationNumber,
    getDriverName
  ],
  (registrationNumber = "", driverName = "") =>
    Map([
      ["registrationNumber", registrationNumber],
      ["driverName", driverName]
    ])
);

const isCanceled = (reservationHistoryItem) =>
  Boolean(reservationHistoryItem.get("cancellationType"));

const isCancelable = (reservationHistoryItem) => [
  rentContractStates.PRE_RESERVATION,
  rentContractStates.RESERVATION
].includes(reservationHistoryItem.get("state")) && !isCanceled(reservationHistoryItem);

const stateToCode = (state) => ({
  [rentContractStates.PRE_RESERVATION]: RESERVATION,
  [rentContractStates.RESERVATION]: RESERVATION,
  [rentContractStates.CHECK_OUT]: CHECK_OUT,
}[state] || COMPLETED);

const newTranslateReservationState = createSelector(
  [newTranslate],
  (translate) => (reservationHistoryItem) => translate(
    isCanceled(reservationHistoryItem)
      ? CANCELLED
      : stateToCode(reservationHistoryItem.get("state"))
  )
);

export const getReservationHistory = createSelector(
  [getRawReservationHistory, newTranslateReservationState],
  (reservationHistory, translateReservationState) => {
    return reservationHistory
      .map(item => item
        .set("isCancelable", isCancelable(item))
        .set("stateDescription", translateReservationState(item))
        .set("formattedCoDateTime", formatDate(item.get("calcCheckOutTimestamp"), "dd.MM.yyyy, HH:mm"))
        .set("formattedCiDateTime", item.get("state") !== rentContractStates.CHECK_OUT
          ? formatDate(item.get("calcCheckInTimestamp"), "dd.MM.yyyy, HH:mm")
          : undefined
        )
        .set("formattedListPriceGross", formatCurrency(item.get("listPriceGross")))
        .set("formattedInvoiceAmountGross", formatCurrency(item.get("invoiceAmountGross"))));
  }
);

function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true; // Same reference or primitive value

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false; // Different types or one is null
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false; // Different number of keys

  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}


